import EmailIcon from 'assets/icons/EmailIcon'
import FieldInstruction from 'Components/Common/FieldInstruction'
import CheckboxGroup from 'Components/input/CheckboxGroup/CheckboxGroup'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { updateProfile } from 'services/api/auth'
import { RootState, store } from 'store'

interface NotificationPreferencesModalProps {
    isOpen: boolean,
    onClose: () => void
}
const NotificationPreferencesModal: React.FC<NotificationPreferencesModalProps> = ({ isOpen, onClose }) => {
    const allNotificationPreferences = useSelector((state: RootState) => state.master.configurations.notification_preferences);

    const currentPreferences = useSelector((state: RootState) => state.auth.notification_preferences);

    const [notificationPreferences, setNotificationPreferences] = useState(currentPreferences);
    const [applying, setApplying] = useState(false);

    useEffect(() => {
        setNotificationPreferences(currentPreferences);
    }, [currentPreferences])

    const apply = async () => {
        try {
            setApplying(true);
            const selectedAgencyId = store.getState().auth.selectedAgencyId;
            if (!selectedAgencyId) throw new Error("Agency Not Selected!");

            const response = await updateProfile(selectedAgencyId, { notification_preferences: notificationPreferences });
            if (response) {
                toast.success("Preferences applied successfully!");
                onClose();
            }
        } catch (error) {
            console.log(error);
            toast.error("There is some issue while applying your preferences, please try again..");
        } finally {
            setApplying(false);
        }
    }


    return (
        <Modal isOpen={isOpen} toggle={() => onClose()}>
            <ModalBody>
                <FormGroup row className='m-0'>
                    <Col sm={12} className='my-1'>
                        <div className="d-flex gap-3">
                            <div className="w-40px">
                                <EmailIcon className='me-2' />
                            </div>
                            <div className="d-flex flex-column gap-2">
                                <Label htmlFor='name' className='form-label input-label mb-0'>
                                    Notification Preferences
                                </Label>
                                <FieldInstruction instruction={"Select the events you want to receive notifications for."} />
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} className='my-1'>
                        <div className='ms-5 mt-3 ps-2'>
                            <CheckboxGroup
                                options={allNotificationPreferences ? allNotificationPreferences.map((pref) => ({ label: pref.label, value: pref.key })) : []}
                                selectedValues={notificationPreferences ?? []}
                                onChange={(selected) => setNotificationPreferences(selected.map((pref) => String(pref)))}
                            />
                        </div>
                    </Col>
                </FormGroup>
            </ModalBody>
            <ModalFooter className='border-top py-3'>
                <div className="d-flex justify-content-end align-items-center gap-3">
                    <button className="theme-btn btn-primary-outlined" onClick={() => onClose()}>Cancel</button>
                    <button className='theme-btn btn-primary' onClick={() => apply()} disabled={applying}>{applying ? "Applying..." : "Apply"}</button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default NotificationPreferencesModal